import type {EmailMakerControlProps} from '../../right-panel-registry.types';

export enum InfoBoxViewport {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export interface InfoBoxDescriptor {
  contentKey: string;
}

export interface ConditionalInfoBoxDescriptor extends InfoBoxDescriptor {
  isVisible: (rawValue: string) => boolean;
}

export interface InfoBoxControlInnerProps extends EmailMakerControlProps {
  descriptor: InfoBoxDescriptor;
}
